//import { HTTP } from '@ionic-native/http/ngx';
import { IonPage, IonInput, IonButton, IonSlides, IonGrid, IonItem, IonTabs, IonTabBar, IonTabButton, IonMenu, IonToolbar, IonTitle, IonContent, IonList, IonHeader, IonMenuToggle, IonLabel, IonSplitPane, IonRouterOutlet, IonFooter, useIonRouter } from '@ionic/react';
import { IonSlide, IonRow, IonCol, IonIcon, IonButtons, IonMenuButton, IonModal, IonText } from '@ionic/react';
import { Link, Router, Redirect, Route, Switch } from "react-router-dom";
import React, { useContext, useEffect, useState } from 'react';
import { IonReactRouter } from '@ionic/react-router';
import {triangle} from 'ionicons/icons';
import {PrivateRoute_client} from '../../../components/PrivateRoute_client';
//import ReactDOM from 'react-dom';

import {Reciepts} from './Tab_Reciepts';
import { Auth_MerchantID_context } from '../../../storeState/auth_merchantID_context';


import { useHistory} from "react-router-dom";
import {ConfirmMerchantLogout} from '../../zPublic/components/MerchantLogout';


const path = 'lib/web/viewer.html';


export function Client_SideMenu (props) {

    let authClient_context = useContext(Auth_MerchantID_context);


    const [acctID, setAccountID ] = useState(authClient_context.acctID);
    const [schema, setSchemaName ] = useState(authClient_context.schema);
    let [baseURL, setBaseURL ] = useState(authClient_context.baseURL);
    let [sessionID, setSessionID ] = useState(authClient_context.sessionID);

    let [confirmLogout, setConfirmLogout] = useState(false);

    let history = useHistory();
    let router = useIonRouter();

    function handleRoute(event)
    {
        // alert(event);
        // alert(window.location.pathname);

        //history.push(event);
        //window.location = event;
        router.push(event, 'forward', 'replace');

        // if(event == '/logout')
        // {
        //     window.location.href = event;
        // }
    }

        return (
               // <IonRouterOutlet>
                    <IonMenu contentId='qavaAppConfirmed' disabled={props.disabled} side='end'>
                        <IonHeader>
                            <IonToolbar> 
                                <IonTitle>
                                    Menu
                                </IonTitle>
                                <IonButtons slot='end'>
                                    <IonMenuButton autoHide='false'></IonMenuButton>
                                </IonButtons>
                            </IonToolbar>
                        </IonHeader>
                        <IonContent>
                            <IonList>
                                    <IonMenuToggle auto-hide='false'>
                                        {/*<Link to='/merchantMainPageApp'>Home</Link>*/}
                                            <IonItem button routerLink='/clientMainPageApp'>
                                                Home
                                            </IonItem>
                                    </IonMenuToggle>
                                    <IonMenuToggle auto-hide='false'>
                                            <IonItem button routerLink='/client_profileSetting'>
                                                Profile
                                            </IonItem>
                                    </IonMenuToggle>
                                    <IonMenuToggle auto-hide='false' >
                                            <IonItem button routerLink='/client_accountSetting'>
                                                Account
                                                {/*<PrivateRoute path="/accountSetting" accountID={ acctID } schemaName={ schema } render={() => <AccountSetting accountID={ acctID } schemaName={ schema } />} />*/}
                                            </IonItem>
                                    </IonMenuToggle>
                                    <IonMenuToggle auto-hide='false'>
                                            <IonItem button onClick={() => setConfirmLogout(true)}>
                                                Logout
                                            </IonItem>
                                    </IonMenuToggle>
                            </IonList> 

                {confirmLogout == true && <ConfirmMerchantLogout openModal={confirmLogout} data={{
                                            source: 'complete_logout',
                                            acctID: acctID,
                                            schema: schema,
                                            sessionID: sessionID,
                                            baseURL: baseURL
                }}></ConfirmMerchantLogout>}
     
                        </IonContent>
                    </IonMenu>
                //</IonRouterOutlet>
        )
    }
